import React, { useState, useRef } from "react";
import SideBarContentNew from "../SideBarContentNew";
import { useLocation } from "react-router-dom";

const SidebarApp = (props) => {
  const { children, className } = props;
  const [expandSidebar, setExpandSidebar] = useState(true);

  const sidebarMouseoverHandler = () => {
    setExpandSidebar(!expandSidebar);
  };
  const location = useLocation();
  const expandedClassName = expandSidebar ? "expanded" : "";
  return (
    <div className={`sidebar-container-new ${expandedClassName} ${className}`}>
      {/* <div className="sidebar-placeholder" /> */}
      {location.pathname !== "/new-home" && (
        <div
          className="sidebar-overlay"
          onClick={() => setExpandSidebar(false)}
        />
      )}

      {/* <div className="sidebar">
        <SideBarContentNew
          onClickLeft={sidebarMouseoverHandler}
          onClickRight={sidebarMouseoverHandler}
        />
      </div> */}
      <div className="sidebar-app">{children}</div>
    </div>
  );
};
export default SidebarApp;
